<template>

    <div>
        <h4 class="mb-6">Adoption status for worker {{worker.name}}</h4>
        <vx-card id="dataDiv"  class="vs-con-loading__container">
            <vs-progress v-if="worker.adoption_status > 0 && worker.adoption_status !== 8" indeterminate color="primary"></vs-progress>
            <vs-progress v-if="worker.adoption_status === 0" :percent="0" color="primary"></vs-progress>
            <vs-progress v-if="worker.adoption_status === 8" :percent="100" color="success"></vs-progress>
            <h5 class="mt-6">Progress</h5>
            <vx-timeline class="mt-6" :data="timelineData" />

            <vs-button class="mt-6" v-if="worker.adoption_status === 8" @click="$router.push('/worker/' + $route.params.id)">Go to worker</vs-button>
        </vx-card>
    </div>

</template>
<script>

    import VxTimeline from '@/components/timeline/VxTimeline'

    export default {
        components: {
            VxTimeline
        },
        data() {
            return {

                worker: {
                    name: '',
                    adoption_status: 0
                },

                updateStatusTimer: ''

            }
        },
        methods: {
            loadData() {
                if (this.worker.name.length === 0) {
                    this.$vs.loading({
                        container: '#dataDiv',
                        type: 'corners',
                        scale: 0.7
                    })
                }

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker/' + this.$route.params.id)
                loadPromise.then(function(response) {
                    thisIns.worker = response.data
                    if (thisIns.worker.adoption_status === 8) {
                        clearInterval(thisIns.updateStatusTimer)
                    }
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$router.push('/workers')
                })

                loadPromise.finally(function() {
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            }
        },
        computed: {
            timelineData() {
                const data = []

                data.push({
                    color: 'dark',
                    icon: 'ZapIcon',
                    title: 'Request received',
                    desc: 'Adoption request was received in management'
                })

                data.push({
                    color: 'dark',
                    icon: 'SunIcon',
                    title: 'Management ready',
                    desc: 'Management server is ready for worker adoption'
                })

                data.push({
                    color: 'dark',
                    icon: 'PlayIcon',
                    title: 'Adoption started',
                    desc: 'Worker received adoption request and started adoption'
                })

                data.push({
                    color: 'dark',
                    icon: 'RefreshCwIcon',
                    title: 'Generating private key',
                    desc: 'Worker started generating own private key for SSL certificate'
                })

                data.push({
                    color: 'dark',
                    icon: 'KeyIcon',
                    title: 'Private key generated',
                    desc: 'Private key generation on worker was successful'
                })

                data.push({
                    color: 'dark',
                    icon: 'UploadCloudIcon',
                    title: 'Certificate request',
                    desc: 'Certificate request with public key was received on management server'
                })

                data.push({
                    color: 'dark',
                    icon: 'AwardIcon',
                    title: 'Certificate generated',
                    desc: 'Worker certificate was successfully generated'
                })

                data.push({
                    color: 'dark',
                    icon: 'DownloadCloudIcon',
                    title: 'Certificate received',
                    desc: 'Worker received signed certificate'
                })

                data.push({
                    color: 'dark',
                    icon: 'CheckCircleIcon',
                    title: 'Adoption finished',
                    desc: 'Worker saved certificate successfully. Adoption finished'
                })

                if (this.worker.adoption_status === 0) return data

                for (let x = 0; x < 9; x++) {
                    if (x <= this.worker.adoption_status) {
                        data[x].color = 'success'
                    } else if (x === this.worker.adoption_status + 1) {
                        data[x].color = 'warning'
                    }
                }

                if (this.worker.adoption_status === 8) {
                    data[8].color = 'success'
                }

                return data
            }
        },
        watch: {
            '$route.params.id': function() {
                clearInterval(this.updateStatusTimer)

                this.loadData()

                this.updateStatusTimer = setInterval(() => { this.loadData() }, 500)
            }
        },
        beforeDestroy() {
            clearInterval(this.updateStatusTimer)
        },
        mounted() {
            this.loadData()
            this.updateStatusTimer = setInterval(() => { this.loadData() }, 500)
        }
    }

</script>
